import { useState } from 'react';
import { testAuthToken, debugAuthToken } from '../../../api/test-auth';

export function TestAuth() {
  const [result, setResult] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [flowId, setFlowId] = useState<string>('');

  const handleTestAuth = async () => {
    if (!flowId.trim()) {
      setResult('Please enter a flow ID');
      return;
    }

    setLoading(true);
    try {
      await testAuthToken(flowId);
      setResult('Check console for test results');
    } catch (error: any) {
      setResult(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleDebugAuth = async () => {
    if (!flowId.trim()) {
      setResult('Please enter a flow ID');
      return;
    }

    setLoading(true);
    try {
      await debugAuthToken(flowId);
      setResult('Check console for auth header details');
    } catch (error: any) {
      setResult(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 border rounded-lg">
      <h2 className="text-lg font-semibold mb-4">Auth Token Test</h2>

      <div className="space-y-4">
        <div className="mb-4">
          <label htmlFor="flowId" className="block text-sm font-medium mb-2">
            Flow ID
          </label>
          <input
            id="flowId"
            type="text"
            value={flowId}
            onChange={(e) => setFlowId(e.target.value)}
            className="w-full px-3 py-2 border rounded-md"
            placeholder="Enter flow ID to test"
          />
        </div>

        <div className="space-x-4">
          <button
            onClick={handleTestAuth}
            disabled={loading}
            className="px-4 py-2 bg-primary text-white rounded hover:bg-primary/90 disabled:opacity-50"
          >
            Test Archive Flows
          </button>

          <button
            onClick={handleDebugAuth}
            disabled={loading}
            className="px-4 py-2 bg-primary text-white rounded hover:bg-primary/90 disabled:opacity-50"
          >
            Debug Auth Headers
          </button>
        </div>

        {loading && <div>Loading...</div>}

        {result && (
          <div className="mt-4 p-4 bg-gray-100 rounded">
            <pre className="whitespace-pre-wrap">{result}</pre>
          </div>
        )}
      </div>
    </div>
  );
}
